const LOGIN = 'oauth/token';
const TOPOLOGY = 'appuser/topology';
const UPGRADE_BUILD = 'buildmgmnt/actionreq';
const BUILD = 'buildmgmnt/build';
const DEVICES_FOR_AREA = 'appuser/area/areaId/devicelist';
const REBOOT = 'device/restart/macId';
const UNPAIR = 'device/unpair/deviceId';
const SCHEDULE_PROFILE = 'device/shadow/macId';
const PIR_DEBUG = "device/pirDebug/macId";
const SESSION_VALIDITY_CHECK = "forAuthCheck";
const SCHEDULE = 'device/schedules/macId';
const SCENE = 'device/scene/macId';
const GOLDEN_BUILD = 'buildmgmnt/golden';
const AUTHORISATION = 'appuser/dashboard';
const GROUP = 'device/group/macId';
const DEVICE_LIST = 'appuser/devices';
const FACTORY_RESET_DEVICE = "device/factoryreset/mac";
const ACTIVATE_DEVICE = "device/activate/mac";
const DEACTIVATE_DEVICE = "device/deactivate/mac";
const GET_ACCOUNT= "accountmgmnt";
const UPDATE_SERVICES="accountmgmnt/services";
const GLOBAL_SETTINGS="device/global-settings/{mac}";



export default {
    LOGIN,
    TOPOLOGY,
    DEVICES_FOR_AREA,
    UPGRADE_BUILD,
    BUILD,
    REBOOT,
    UNPAIR,
    PIR_DEBUG,
    SCHEDULE_PROFILE,
    SESSION_VALIDITY_CHECK,
    SCHEDULE,
    SCENE,
    GLOBAL_SETTINGS,
    GOLDEN_BUILD,
    AUTHORISATION,
    GROUP,
    DEVICE_LIST,
    FACTORY_RESET_DEVICE,
    ACTIVATE_DEVICE,
    DEACTIVATE_DEVICE,
    GET_ACCOUNT,
    UPDATE_SERVICES
}